var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["phone-select"].concat(_vm.variantClasses) },
    [
      _c(
        "div",
        { staticClass: "phone-select__item" },
        [
          _c("v-select", {
            key: "select--field",
            ref: "selectField",
            attrs: {
              "default-option": _vm.prefixes[18].value,
              options: _vm.prefixes,
              variant: "simple"
            },
            on: {
              input: function(value) {
                return (_vm.prefix = value)
              }
            }
          }),
          _vm._v(" "),
          _c("v-input", {
            ref: "phoneField",
            staticClass: "custom__input",
            attrs: {
              "original-value": _vm.number,
              placeholder: _vm.$t("common.input.phone.placeholder"),
              validation: ["required", "phone"]
            },
            model: {
              value: _vm.number,
              callback: function($$v) {
                _vm.number = $$v
              },
              expression: "number"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-button",
        {
          staticClass: "phone-select__button",
          attrs: { variant: _vm.variant !== "blue" ? "white" : "primary" },
          nativeOn: {
            click: function($event) {
              return _vm.sendForm($event)
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.$t(_vm.buttonLabel)) + "\n\t")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }